import { getRequestData, searchRequestData, updateRequestData } from '../../Utility/apiHelper';
import { handleValidateCodevalue } from '../../Utility/constant';
import { requestHideDialogLoader, requestHideLoader, requestShowDialogLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';

export const requestGetTemplate =(url,queryparams)=>async(dispatch)=>{

    dispatch(requestShowLoader())
     try {
         dispatch({
            type: actionType.REQUEST_GET_TEMPLATE,
        })
        const responsedata = await searchRequestData(queryparams , url , false)
        dispatch({
            type: actionType.RECEIVED_TEMPLATE,
            payload: responsedata?.data
        })
        
    } catch(error) {
        if(error?.response?.status !== 401) {
            dispatch({
                type: actionType.RECEIVED_ERROR,
                payload : []
            })
        }
    }
finally{
    dispatch(requestHideLoader())
    }
}


export const requestGetSpecificTemplate =(url)=>async(dispatch)=>{

    dispatch(requestShowLoader())
     try {
         dispatch({
            type: actionType.REQUEST_GET_SPECIFIC_TEMPLATE,
        })
        const responsedata = await getRequestData(url)
        dispatch({
            type: actionType.RECEIVED_SPECIFIC_TEMPLATE,
            payload: responsedata?.data
        })
        
    } catch(error) {
        if(error?.response?.status == 401) {
            dispatch({
            type: actionType.RECEIVED_ERROR,
        })
    }
}

    dispatch(requestHideLoader())
}

export const requestEmptySpecificTemplate =()=>async(dispatch)=>{

         dispatch({
            type: actionType.EMPTY_SPECIFIC_TEMPLATE,
            payload : {}
        })
}

export const requestUpdateTemplate =(notificationPayload,url,enqueueSnackbar,internationalise)=>async(dispatch)=>{

    dispatch(requestShowLoader())
     try {
         dispatch({
            type: actionType.REQUEST_UPDATE_TEMPLATE,
        })
        const response = await updateRequestData(notificationPayload, url);
        
        if (response?.status === 'error' || response?.status >= 400) {
            dispatch({
                type: actionType.RECEIVED_ERROR,
            })
            enqueueSnackbar(handleValidateCodevalue(internationalise, response?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN'),{variant : 'error'})
        } else {
            dispatch({
                type: actionType.UPDATED_TEMPLATE_SUCCESSFULLY,
            })
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY'),{variant : 'success'})
        }
        return response;
    } catch(error) {
        if(error?.response?.status == 401) {
            dispatch({
            type: actionType.RECEIVED_ERROR,
        })
        }
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'),{variant : 'error'})
        return { status: 'error', propererror: error?.response };
    }
    
    dispatch(requestHideLoader())
}

export const requestGetTemplateList =(url)=>async(dispatch)=>{

    dispatch(requestShowDialogLoader())
     try {
         dispatch({
            type: actionType.REQUEST_GET_TEMPLATE_LIST,
        })
        const responsedata = await getRequestData(url)
        const filteredData = responsedata?.data?.filter(item => item?.systemTemplateFlag !== "COMMON_YES") || []
        dispatch({
            type: actionType.RECEIVED_TEMPLATE_LIST,
            payload: filteredData
        })
        
    } catch(error) {
        if(error?.response?.status == 401) {
            dispatch({
            type: actionType.RECEIVED_ERROR,
        })
    }
}
finally{
    dispatch(requestHideDialogLoader())
}
}

export const emptyTemplateList =()=>async(dispatch)=>{
    dispatch({
            type: actionType.EMPTY_TEMPLATE_LIST,
        })
}

export const requestGetWebToLeadDetails =()=>async(dispatch)=>{

    dispatch(requestShowLoader())
    const url = `${process.env.REACT_APP_BASE_URL}web-to-lead`
     try {
        const responsedata = await getRequestData(url)
        if(responsedata?.status === 200){
        dispatch({
            type: actionType.RECEIVED_WEB_TO_LEAD_DATA,
            payload : responsedata?.data
     })
    }
    } catch(error) {
        if(error?.response?.status !== 401) {
            dispatch({
                type: actionType.RECEIVED_ERROR,
                payload : []
            })
        }
    }
finally{
    dispatch(requestHideLoader())
    }
}
